import { Action } from 'redux'
import { InvoiceActions } from '../../reducers/invoice/actionNames'

const reloadInvoice = (): IInvoiceReload => ({
  type: InvoiceActions.Reload,
})

export type IInvoiceReload = Action<InvoiceActions.Reload>

export default reloadInvoice
